import { useOrganizationSettings } from '../../settings/useOrganizationSettings/useOrganizationSettings';
import { defaultOrganizationBlobSettings } from '../constants/constants';
import { IOrganizationGlobalSettings } from '../types/OrganizationGlobalSettings';
import { IOrganizationSettings } from '../types/OrganizationSettings';
import useOrganizationSettingsUpdate from '../useOrganizationSettingsUpdate/useOrganizationSettingsUpdate';
import useSettingsUpdate from '../useSettingsUpdate/useSettingsUpdate';

const defaultSettings = defaultOrganizationBlobSettings.global;

export default function useOrganizationSettingsGlobalUpdate() {
  const settings = useOrganizationSettings()?.global ?? defaultSettings;
  const updateSettings = useOrganizationSettingsUpdate();
  return useSettingsUpdate<IOrganizationSettings, IOrganizationGlobalSettings>(settings, updateSettings, 'global');
}
